<template>
  <v-app>
    <template v-if="!loading">
      <router-view />
    </template>
    <template v-else>
      <VueLoading />
    </template>
  </v-app>
</template>

<script lang="ts">
import Vue from 'vue';
import { defineComponent } from "vue";
import JwtDecode from 'jwt-decode';
import { auth0Module } from '@/store/dataModules/auth0Module';
import LocalDataService from '@/service/LocalDataService';
import { meModule } from '@/store/dataModules/meModule';
import { Authorizer } from 'chaild-api/src/common/entity/aws/authorize';
import VueLoading from '@/components/pages/Loding.vue';

import { ErrorType } from '@/api/ApiClient';
import { MeResponse } from 'chaild-api/lib';
import { pusherModule } from './store/dataModules/pusherModule';

export default defineComponent({
  name: 'App',

  components: {
    VueLoading,
  },

  data: () => ({
    routePath: '',
    loading: false,
    me: null as MeResponse | null,
  }),
  created: async function() {
    console.log('app created');
    this.loading = true;
    this.routePath = this.$route.path;
    try {
      // バージョン確認
      await meModule.fetchVersion();
      const localVersion = LocalDataService.getVersion();
      const current = meModule.currentVersion?.currentVersion;
      if (current) {
        const currentVersion = current.slice(1);
        if (localVersion) {
          const local = localVersion.split('\.');
          const cur = currentVersion.split('\.');
          if (local[0] == cur[0] && local[1] == cur[1]) {
            console.log('現在は最新のバージョンです');
          } else {
            LocalDataService.setVersion(current.slice(1));
            window.location.reload();
          }
        } else {
          LocalDataService.setVersion(current.slice(1));
          window.location.reload();
        }
      }

      // 認証チェック
      await auth0Module.initClient();
      const isAuthenticated = await auth0Module.isAuthenticated();
      if (isAuthenticated) {
        this.me = await meModule.fetchMe();
        this.isToFirstStep();
      } else {
        try {
          await auth0Module.getTokenSilently();
          this.me = await meModule.fetchMe();
          this.isToFirstStep();
        } catch (error) {
          // console.log('error catch getTokenSilently:', error);
          if (this.$route.query && this.$route.query.code && this.$route.query.state) {
            await auth0Module.handleAuth0();
            await auth0Module.getTokenSilently();
            this.me = await meModule.fetchMe();
            this.isToFirstStep();
            return;
          }
          console.log('再度サインインプロセスへ');
          const apiUrl = process.env.VUE_APP_API_URL || '';
          const isLocalExpress = apiUrl.includes('localhost:3000') || apiUrl.includes('127.0.0.1:3000');
          if (!isLocalExpress) {
            await auth0Module.signinProcess();
          }
        }
      }
    } catch (error) {
      switch (error) {
        case ErrorType.FIRSTLOGIN:
          try {
            await meModule.postMe();
            const apiUrl = process.env.VUE_APP_API_URL || '';
            const isLocalExpress = apiUrl.includes('localhost:3000') || apiUrl.includes('127.0.0.1:3000');
            if (!isLocalExpress) {
              await auth0Module.signinProcess();
            }
          } catch {
            console.log('エラーのためサインインプロセスへ', error);
            const apiUrl = process.env.VUE_APP_API_URL || '';
            const isLocalExpress = apiUrl.includes('localhost:3000') || apiUrl.includes('127.0.0.1:3000');
            if (!isLocalExpress) {
              await auth0Module.signinProcess();
            }
          }
      }
    } finally {
      this.loading = false;
    }
  },

  methods: {
    async isToFirstStep() {
      const user = LocalDataService.getUser();
      if (user) {
        let nurserySchool = user.nurserySchools.find(nursery => nursery.isDefault === true);
        if (user.nurserySchools.length === 0) {
          this.$router.push('/signup');
        }
        if (!nurserySchool) {
          nurserySchool = user.nurserySchools[0];
        }
        const currentUserId = `${nurserySchool.userId}`;
        const token = await auth0Module.getAuth0Token();
        if (currentUserId && token) {
          console.log('set auth');
          LocalDataService.setPushAuthorizer(`${token},${currentUserId}`);
        }
      }
      if (this.me && this.me.nurserySchools.length > 0) {
        pusherModule.subscribe();
        this.loading = false;
        console.log(`this.routePath: ${this.routePath}`)
        if (this.routePath == '/signin' || this.routePath == '/signup' || this.routePath == '/') {
          this.$router.push('/');
          // 引数を1つだけ渡す（移動先のパス）
          this.$router.push('/').catch(err => {
            // ナビゲーション中に発生したエラーをここでキャッチ(重複したナビゲーションエラー)
            if (err.name !== 'NavigationDuplicated') {
              throw err;
            }
          });
        }
      } else {
        this.loading = false;
        this.$router.push('/signup');
      }
    },
  },
});
</script>
<style lang="scss" scoped>
@use '@/sass/ress.scss' as *;
</style>
